import React from 'react'
import 'semantic-ui-css/semantic.min.css'
import { Provider } from 'react-redux'
import store from './store/index'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import AppLayoutRoute from './components/layout'
import Login from './components/login'
import ForgottenPassword from './components/login/ForgottenPassword'
import Dashboard from './components/dashboard'
import Glossary from './components/glossary'
import Endpoint from './components/endpoint'
import Applications from './components/applications'
import './App.css'

function App() {
  return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Switch>
              <Route exact path='/' component={Login}/>
              <Route exact path='/forgotten-password' component={ForgottenPassword}/>
              <AppLayoutRoute exact path='/dashboard' component={Dashboard}/>
              <AppLayoutRoute exact path='/endpoint/:id?' component={Endpoint}/>
              <AppLayoutRoute exact path='/applications/:id?' component={Applications}/>
              <AppLayoutRoute exact path='/glossary/:page?/:status?' component={Glossary}/>
            </Switch>
          </div>
        </Router>
      </Provider>
  );
}

export default App;
